import produce from "immer";
import { CustomizationState } from "..";
import { findPage } from "../../../utils/customization/finders";

export interface RemovePictureAction {
  editablePictureKey: string;
  pageKey: string;
  type: "removePicture";
}

export function removePicture(
  state: CustomizationState,
  action: RemovePictureAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { editablePictureKey, pageKey } = action;

    const selectedPage = findPage(pageKey, draftState.content);

    const selectedPictureIndex = selectedPage.editablePictures.findIndex(
      (picture) => picture.editablePictureKey === editablePictureKey
    );
    if (selectedPictureIndex > -1) {
      selectedPage.editablePictures.splice(selectedPictureIndex, 1);
    }
  });
}
